import React, { useEffect } from 'react';
import { ShieldAlert, LifeBuoy } from 'lucide-react';
import SEO from '../components/SEO';
import RichText from '../components/RichText';
import CtaSection from '../components/CtaSection';
import PageHero from '../components/PageHero';
import { cyberContent } from '../data/siteContent';
import './About.css';

const Cybersecurity = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <SEO
        page="cybersecurite"
        breadcrumb={[{ name: 'Accueil', path: '/' }, { name: 'Cybersécurité', path: '/cybersecurite' }]}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Service',
          name: 'Cybersécurité des infrastructures IT',
          serviceType: 'Cybersécurité',
          provider: { '@type': 'LocalBusiness', name: 'Symplicity', url: 'https://www.symplicity.fr' },
          areaServed: ['Essonne', 'Seine-et-Marne', 'Paris', 'Île-de-France'],
          description: 'Audit de sécurité, pentest, PRA/PCA, sensibilisation et remédiation post-incident pour TPE, PME et collectivités.'
        }}
      />
      <div className="service-page theme-blue" data-testid="cybersecurity-page">

        <PageHero
          symbol="blue"
          title={cyberContent.title}
          subtitle={cyberContent.subtitle}
          testId="cybersecurity-hero"
        />

        <section className="section">
          <div className="container container-narrow">
            <RichText blocks={cyberContent.intro} className="lead fade-in-up" />
          </div>
        </section>

        <section className="section section-alt">
          <div className="container container-narrow">
            <RichText blocks={cyberContent.blocks} />
          </div>
        </section>

        <section className="section">
          <div className="container service-lists">
            <div className="panel fade-in-up">
              <h2 className="list-title"><ShieldAlert size={22} /> {cyberContent.preventive.title}</h2>
              <ul className="check-list">
                {cyberContent.preventive.items.map((item) => <li key={item}>{item}</li>)}
              </ul>
            </div>

            <div className="panel fade-in-up" style={{ animationDelay: '0.1s' }}>
              <h2 className="list-title"><LifeBuoy size={22} /> {cyberContent.curative.title}</h2>
              <p className="list-intro">{cyberContent.curative.intro}</p>
              <ul className="check-list">
                {cyberContent.curative.items.map((item) => <li key={item}>{item}</li>)}
              </ul>
            </div>
          </div>
        </section>

        <section className="section section-alt">
          <div className="container">
            <span className="eyebrow">Nos solutions</span>
            <h2 className="section-title">{cyberContent.solutions.title}</h2>
            <p className="section-subtitle">{cyberContent.solutions.intro}</p>
            <div className="solutions-grid">
              {cyberContent.solutions.items.map((item, index) => (
                <div key={item.name} className="solution-card fade-in-up" style={{ animationDelay: `${index * 0.06}s` }}>
                  <span className="solution-name">{item.name}</span>
                  <span className="solution-value">{item.value}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container">
            <div className="label-block">
              <div className="label-block-text">
                <h2 className="section-title">{cyberContent.label.title}</h2>
                <RichText blocks={cyberContent.label.blocks} />
              </div>
              <div className="label-block-logos">
                <img src="/assets/certifications/professionnel-reference.jpg" alt="Professionnel référencé Cybermalveillance.gouv.fr" />
              </div>
            </div>
          </div>
        </section>

        <CtaSection title={cyberContent.ctaTitle} text={cyberContent.ctaText} testId="cyber-cta" />
      </div>
    </>
  );
};

export default Cybersecurity;
